import { testId } from '../../utils';
import * as React from 'react';
import { PropsWithChildren } from 'react';

type BannerProps = {
  visible?: boolean;
  'data-testid': string;
};

export const Banner: React.FC<PropsWithChildren<BannerProps>> = ({
  children,
  visible = true,
  'data-testid': dataTestId,
}) => {
  if (!visible) {
    return null;
  }
  return (
    <div
      {...testId(dataTestId, 'banner')}
      className="w-full bg-black-light text-white flex p-3 items-center justify-center hidden md:flex"
    >
      {children}
    </div>
  );
};
